// i18n 翻譯字典 — key → (locale → 譯文)。
//
// 目前涵蓋主要 UI 字串的 en / zh-Hant / zh-Hans / ja-JP 四語系（代表繁中/簡中/日/英）；
// 其餘 9 語系（ko-KR/th/vi/id/my-MM/bn/pt/es-ES/tr-TR）暫回退 en，完整字串可再由 Unity
// Data/Localization 各語系 String Table 匯出補齊（屬機械性擴充，不影響 i18n 引擎與 t() 用法）。
// 缺某 key 的當前語系時，t() 依 當前語系 → en → key 後備，不致崩壞。

export const MESSAGES: Record<string, Record<string, string>> = {
  'app.title': {
    en: 'Little Red Riding Hood',
    'zh-Hant': '小紅帽',
    'zh-Hans': '小红帽',
    'ja-JP': '赤ずきん',
  },
  'loading.tagline': {
    en: 'Loading…',
    'zh-Hant': '載入中…',
    'zh-Hans': '加载中…',
    'ja-JP': '読み込み中…',
  },
  'reward.congrats': {
    en: 'Congratulations',
    'zh-Hant': '恭喜',
    'zh-Hans': '恭喜',
    'ja-JP': 'おめでとう',
  },
  'reward.freeSpins': {
    en: 'Free Spins',
    'zh-Hant': '免費遊戲',
    'zh-Hans': '免费游戏',
    'ja-JP': 'フリースピン',
  },
  'reward.won': {
    en: 'You Won',
    'zh-Hant': '贏得',
    'zh-Hans': '赢得',
    'ja-JP': '獲得',
  },
  // FG 進場字卡（對照 Unity FreeSpinsUI）。字圖 tx_youHaveWon/tx_collectScatters 已接線
  // （UiTextures per-locale），以下文字為字圖未載入時的 fallback。
  'reward.youHaveWon': {
    en: 'You Have Won',
    'zh-Hant': '你贏得了',
    'zh-Hans': '你赢得了',
    'ja-JP': '獲得',
  },
  'reward.collectScatterPre': {
    en: 'Collect',
    'zh-Hant': '收集',
    'zh-Hans': '收集',
    'ja-JP': '収集',
  },
  'reward.collectScatterPost': {
    en: 'to level up — up to Level 3',
    'zh-Hant': '以進行升級 - 最高可達 3 級',
    'zh-Hans': '以进行升级 - 最高可达 3 级',
    'ja-JP': 'を集めてレベルアップ — 最大3レベル',
  },
  'reward.collectScatterReward': {
    en: 'Win higher multipliers and free spin rewards!',
    'zh-Hant': '贏取更高的乘數與免費旋轉獎勵！',
    'zh-Hans': '赢取更高的乘数与免费旋转奖励！',
    'ja-JP': 'より高い倍率とフリースピン報酬を獲得！',
  },
  // FG 進場字卡的點擊提示（Unity FreeSpinsUI HintText「Press anywhere to continue」；
  // 該 Common Table key 未在字串匯出內，故手寫補齊）。
  'reward.pressAnywhere': {
    en: 'Press anywhere to continue',
    'zh-Hant': '點擊任意處繼續',
    'zh-Hans': '点击任意处继续',
    'ja-JP': '画面をタップして続行',
  },
  'tier.none': {
    en: 'Free Spins Over',
    'zh-Hant': '免費遊戲結束',
    'zh-Hans': '免费游戏结束',
    'ja-JP': 'フリースピン終了',
  },
  'tier.big': { en: 'Big Win', 'zh-Hant': '大獎', 'zh-Hans': '大奖', 'ja-JP': 'ビッグウィン' },
  'tier.mega': { en: 'Mega Win', 'zh-Hant': '巨額大獎', 'zh-Hans': '巨额大奖', 'ja-JP': 'メガウィン' },
  'tier.super': { en: 'Super Win', 'zh-Hant': '超級大獎', 'zh-Hans': '超级大奖', 'ja-JP': 'スーパーウィン' },
  'tier.epic': { en: 'Epic Win', 'zh-Hant': '史詩大獎', 'zh-Hans': '史诗大奖', 'ja-JP': 'エピックウィン' },
  'tier.max': { en: 'Max Win', 'zh-Hant': '最高贏分', 'zh-Hans': '最高赢分', 'ja-JP': 'マックスウィン' },
  'multiplier.caption': {
    en: 'MULTI',
    'zh-Hant': '倍  率',
    'zh-Hans': '倍  率',
    'ja-JP': '倍  率',
  },
  'collector.title': {
    en: 'Collect Scatter',
    'zh-Hant': '收集 Scatter',
    'zh-Hans': '收集 Scatter',
    'ja-JP': 'スキャッター収集',
  },
  'common.confirm': { en: 'Confirm', 'zh-Hant': '確認', 'zh-Hans': '确认', 'ja-JP': '確認' },
  'common.cancel': { en: 'Cancel', 'zh-Hant': '取消', 'zh-Hans': '取消', 'ja-JP': 'キャンセル' },
  // Ways 木牌標籤（Unity 為 WaysImage 美術，無對應 String Table key）。
  'ways.label': { en: 'WAYS', 'zh-Hant': '組合方式', 'zh-Hans': '组合方式', 'ja-JP': '組み合わせ' },
  // 資訊頁的兩個補漏 key：其餘文字全部走 Unity 真實 13 語系字串（game.Info_*／common.Info_*）。
  // `CHARACTERS WILD` 這個標題在 Unity 是**硬編英文**（該節點沒有 LocalizeStringEvent，同表內卻有其他標題的 key，
  // 屬來源漏在地化）；本移植改走這個手寫 key，非英文語系才不會突兀跳出英文。
  'info.charactersWild': {
    en: 'CHARACTERS WILD',
    'zh-Hant': '角色百搭',
    'zh-Hans': '角色百搭',
    'ja-JP': 'キャラクターWILD',
  },
  // 後端 ClientOptions.RTP 未提供時附加的註記（Unity 沒有這段：它一定拿得到後端值）。
  'info.rtpFallbackNote': {
    en: '(Indicative value; the actual RTP is provided by the server.)',
    'zh-Hant': '（示意值，實際 RTP 由後端提供。）',
    'zh-Hans': '（示意值，实际 RTP 由后端提供。）',
    'ja-JP': '（参考値・実際のRTPはサーバーが提供します。）',
  },
}
